export default "__VITE_ASSET__GE58O0Sm__"